"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPlayerAppearance = exports.save = exports.get = exports.hats = exports.skinColors = exports.appearances = void 0;
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("../../../sprites/spritesUtil-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var baseKey = 'rogue:character:';
var nameKey = baseKey + 'name';
var appearanceKey = baseKey + 'appearance';
var colorKey = baseKey + 'color';
var hatKey = baseKey + 'hat';
exports.appearances = [
    { value: 'normal', sprite: sprites_sidecar_1.sprites.rogue70 },
    { value: 'frown', sprite: sprites_sidecar_1.sprites.rogue71 },
    { value: 'surprised', sprite: sprites_sidecar_1.sprites.rogue72 },
    { value: 'meh', sprite: sprites_sidecar_1.sprites.rogue73 },
    { value: 'smirk', sprite: sprites_sidecar_1.sprites.rogue74 },
    { value: 'mustache', sprite: sprites_sidecar_1.sprites.rogue75 },
    { value: 'angry', sprite: sprites_sidecar_1.sprites.rogue76 },
    { value: 'frog', sprite: sprites_sidecar_1.sprites.rogue77 },
    { value: 'goatee', sprite: sprites_sidecar_1.sprites.rogue66 },
    { value: 'hmm', sprite: sprites_sidecar_1.sprites.rogue67 },
];
exports.skinColors = [
    { value: 'light', color: rogueDef_sidecar_1.rogueDef.colors.light },
    { value: 'brown', color: rogueDef_sidecar_1.rogueDef.colors.brown },
    { value: 'black', color: rogueDef_sidecar_1.rogueDef.colors.pureBlack },
    { value: 'orange', color: rogueDef_sidecar_1.rogueDef.colors.orange },
    { value: 'red', color: rogueDef_sidecar_1.rogueDef.colors.red },
    { value: 'blue', color: rogueDef_sidecar_1.rogueDef.colors.lightBlue },
    { value: 'green', color: rogueDef_sidecar_1.rogueDef.colors.green },
];
exports.hats = [
    { value: 'no hat', sprite: null },
    { value: 'fedora', sprite: sprites_sidecar_1.sprites.rogue55 },
    { value: 'top hat', sprite: sprites_sidecar_1.sprites.rogue57 },
    { value: 'cat ears', sprite: sprites_sidecar_1.sprites.rogue56 },
];
var _obj = null;
var get = function () {
    if (!_obj) {
        var getNumber = function (key) {
            return parseInt(localStorage.getItem(key) || '0') || 0;
        };
        _obj = {
            name: localStorage.getItem(nameKey) || 'Rogue',
            appearanceIdx: getNumber(appearanceKey),
            skinColorIdx: getNumber(colorKey),
            hatIdx: getNumber(hatKey),
        };
    }
    return _obj;
};
exports.get = get;
var save = function () {
    var obj = (0, exports.get)();
    localStorage.setItem(nameKey, obj.name);
    localStorage.setItem(appearanceKey, '' + obj.appearanceIdx);
    localStorage.setItem(colorKey, '' + obj.skinColorIdx);
    localStorage.setItem(hatKey, '' + obj.hatIdx);
};
exports.save = save;
var setPlayerAppearance = function (c) {
    var obj = (0, exports.get)();
    var appearance = entitiesUtils_sidecar_1.entitiesUtils.wrappedGet(exports.appearances, obj.appearanceIdx);
    var color = entitiesUtils_sidecar_1.entitiesUtils.wrappedGet(exports.skinColors, obj.skinColorIdx);
    var hat = entitiesUtils_sidecar_1.entitiesUtils.wrappedGet(exports.hats, obj.hatIdx);
    spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image, sprites_sidecar_1.sprites.rogue51[0]);
    spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image2, sprites_sidecar_1.sprites.rogue61[0]);
    spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image3, appearance.sprite[0]);
    c.image2.visible = c.image3.visible = c.image.visible;
    c.image.tint = color.color;
    c.image2.tint = color.color;
    c.image3.tint = color.color;
    c.imageStatus.tint = color.color;
    if (hat.sprite) {
        c.image4.visible = c.image.visible;
        spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image4, hat.sprite[0]);
    }
    else {
        c.image4.visible = false;
    }
};
exports.setPlayerAppearance = setPlayerAppearance;
